import http from '@/utils/http';

const baseUrl = '/noticia';

export default {
    buscarNoticias() {
        return http.get({
            url: baseUrl + `/buscar`,
            lockScreen: false
        });
    }
};
